<template>
  <div>
    <div :class="getClass(type)">
      <md-icon :class="getIconClass(type)">{{ icon }}</md-icon>
      {{ message }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      default: 'check_circle_outline'
    },
    message: {
      type: String,
      default: 'You have a new notification'
    },
    type: {
      type: String,
      default: 'success'
    }
  },
  methods: {
    getClass(type) {
      switch (type) {
        case 'success':
          return "success-box";
        case 'warning':
          return 'warning-box';
        default:
          return 'alert-box';
      }
    },
    getIconClass(type){
      switch (type) {
        case 'success':
          return "md-primary";
        case 'warning':
            return 'md-warning';
        default:
          return 'md-danger';
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";

.success-box,.alert-box,.warning-box {
  padding:10px;
  border:1px solid;
  margin-right: 10px;
}
.success-box{
  border-color: $ausloans-green;
  background: $ausloans-green-light;
}
.alert-box{
  border-color: $ausloans-red;
  background: $ausloans-red-light;
}
.warning-box{
  border-color: $ausloans-orange;
  background: $ausloans-orange-light;
}
</style>
